import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "reset-password-link" */ './index'),
  loading: () => null,
})
